import { Link as RouterLink } from 'react-router-dom'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { EmptyState } from '../ui/QueryState'

export function NotFound() {
  return (
    <EmptyState title="Page not found">
      <Typography color="text.secondary">There is nothing at this address. Use the menu to find what you were looking for.</Typography>
      <Button component={RouterLink} to="/">
        Start again
      </Button>
    </EmptyState>
  )
}
